import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CHART_COLORS } from '../../../utils/chartColors';
import EmptyState from '../../../components/ui/EmptyState';

export default function TimeInStepView({ data }) {
  if (data.steps.length === 0) return <EmptyState title="No processed steps in this range." />;

  return (
    <div>
      <p className="mb-4 text-sm text-gray-600">Average days spent per step, slowest first — highlights bottlenecks.</p>
      <ResponsiveContainer width="100%" height={Math.max(240, data.steps.length * 28)}>
        <BarChart data={data.steps} layout="vertical" margin={{ left: 24 }}>
          <CartesianGrid strokeDasharray="0" horizontal={false} stroke={CHART_COLORS.grid} />
          <XAxis type="number" tick={{ fill: CHART_COLORS.axis, fontSize: 12 }} axisLine={false} tickLine={false} unit="d" />
          <YAxis type="category" dataKey="title" width={220} tick={{ fill: CHART_COLORS.axis, fontSize: 12 }} axisLine={false} tickLine={false} />
          <Tooltip contentStyle={{ borderRadius: 8, borderColor: CHART_COLORS.grid, fontSize: 13 }} formatter={(v) => `${v} days`} />
          <Bar dataKey="avg_days" fill={CHART_COLORS.primary} radius={[0, 4, 4, 0]} maxBarSize={16} />
        </BarChart>
      </ResponsiveContainer>

      <table className="mt-4 min-w-full divide-y divide-gray-100 text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wide text-gray-400">
            <th className="py-2">Step</th>
            <th className="py-2">Avg days</th>
            <th className="py-2">Sample size</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {data.steps.map((s) => (
            <tr key={s.code}>
              <td className="py-2 text-gray-700">{s.title}</td>
              <td className="py-2 text-gray-700">{s.avg_days}</td>
              <td className="py-2 text-gray-700">{s.sample_size}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
